// extracted by mini-css-extract-plugin
export default {"activeText":"Link-module_activeText-R6NiT"};